export default __webpack_public_path__ + "bedd9dda935a164e00f07738e7b799f7.woff";